import React from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sileo';
import 'wwtc-sdk/dist/index.css';
import App from './App';
import { toasterProps } from './notifications';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <>
        <Toaster {...toasterProps} />
        <App />
    </>,
);
